/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description':
    'Pyydä tukea tiimiltä tai ylläpitäjältä.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title':
    'Tälle haulle ei voitu hakea tuloksia',
};
